<template>
  <div>
    <el-form
      ref="form"
      :rules="rules"
      label-width="140px"
      :model="form"
      :hide-required-asterisk="false"
    >
      <div style="display: flex">
        <el-form-item label="项目名称:" prop="xmbh" style="width: 50%">
          <el-select
            ref="xmList"
            v-model="form.xmbh"
            placeholder="全部"
            class="filter-item"
            style="width: 100%"
            filterable
            :disabled="disableXm"
            @change="handleXm"
          >
            <el-option
              v-for="item in zxlc.xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否到岗:" prop="bgzt">
          <el-radio-group v-model="form.bgzt" size="small">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="form.bgzt == 1">
        <div>
          <div style="font-size: 16px; padding: 15px 0 30px 0">
            原一把手信息
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <el-form-item label="姓名:" prop="yrxm" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入姓名"
                maxlength="50"
                v-model="form.yrxm"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="职务:" prop="yrzw" style="width: 50%">
              <el-select
                ref="name"
                v-model="form.yrzw"
                placeholder="请选择职务"
                :clearable="false"
                filterable
                class="filter-item"
                style="width: 100%"
              >
                <el-option
                  v-for="item in zxlc.gxrjsList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item> -->
            <el-form-item label="离任时间:" prop="rlsj" style="width: 50%">
              <el-date-picker
                v-model="form.rlsj"
                align="right"
                type="date"
                placeholder="选择日期"
                :clearable="false"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="离任后去向:" prop="rlqx" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入去向"
                maxlength="50"
                v-model="form.rlqx"
              ></el-input>
            </el-form-item>
            <el-form-item label="离任后职务:" prop="rlhzw" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入职务"
                maxlength="50"
                v-model="form.rlhzw"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div>
          <div style="font-size: 16px; padding: 15px 0 30px 0">
            新任一把手信息
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <el-form-item label="姓名:" prop="ybsxm" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入姓名"
                maxlength="50"
                v-model="form.ybsxm"
              ></el-input>
            </el-form-item>
            <el-form-item label="到岗时间:" prop="dgrq" style="width: 50%">
              <el-date-picker
                v-model="form.dgrq"
                align="right"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="现任职务:" prop="xrzw" style="width: 50%">
              <el-select
                ref="name"
                v-model="form.xrzw"
                placeholder="请选择职务"
                :clearable="false"
                filterable
                class="filter-item"
                style="width: 100%"
              >
                <el-option
                  v-for="item in zxlc.gxrjsList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item> -->
            <el-form-item label="原工作单位:" prop="ygzdw" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入原工作单位"
                maxlength="50"
                v-model="form.ygzdw"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="原工作单位职务:"
              prop="ygzdwzw"
              style="width: 50%"
            >
              <el-input
                show-word-limit
                placeholder="请输入原工作单位职务"
                maxlength="50"
                v-model="form.ygzdwzw"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系方式:" prop="phone" style="width: 50%">
              <el-input
                show-word-limit
                placeholder="请输入联系方式"
                maxlength="50"
                v-model="form.phone"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="是否认可天维:"
              prop="attitude"
              style="width: 50%"
            >
              <el-select
                ref="name"
                v-model="form.attitude"
                placeholder="请选择"
                :clearable="false"
                filterable
                class="filter-item"
                style="width: 100%"
              >
                <el-option
                  v-for="item in zxlc.khtdList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="是否与天维合作过:"
              prop="relation"
              style="width: 50%"
            >
              <el-select
                ref="name"
                v-model="form.relation"
                placeholder="请选择"
                :clearable="false"
                filterable
                class="filter-item"
                style="width: 100%"
              >
                <el-option
                  v-for="item in zxlc.zwgxList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              label="工作履历:"
              prop="work_experience"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="通过各种途径了解新任人员的工作履历，为后续的拜访环节做准备，可以通过其他行领导及牵头部门、其他业务部门了解。"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.work_experience"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="性格特征(选填):"
              prop="charact"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="了解新任人员的性格特征，便于后续拜访策略的制定，可以通过具体的事件及行为确定性格特征（老虎型、孔雀型、猫头鹰、考拉型）。"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.charact"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="兴趣爱好(选填):"
              prop="hobbies"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="请输入兴趣爱好"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.hobbies"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="特殊细节(选填):"
              prop="details"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="请输入特殊细节"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.details"
              ></el-input>
            </el-form-item> -->
            <el-form-item
              label="对我方拜访的有利因素(选填):"
              prop="ylys"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="请输入有利因素"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.ylys"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="对我方拜访的不利因素(选填):"
              prop="blys"
              style="width: 100%"
            >
              <el-input
                show-word-limit
                placeholder="请输入不利因素"
                maxlength="500"
                rows="3"
                type="textarea"
                v-model="form.blys"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { saveYbsbgsq, getYbsbgsqById, insertProgram } from "@/api/zxlc.js";
import { mapGetters } from "vuex";
import { formatMomentDate, validatePhoneTwo } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
const validatePhoneTwoRuler = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("联系方式不能为空"));
  } else {
    if (validatePhoneTwo(rule, value, callback)) {
      callback();
    } else {
      return callback(new Error("联系方式格式不正确"));
    }
  }
};

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      form: {
        id: null,
        xmbh: null,
        rlsj: null,
        ygzdw: null,
        ygzdwzw: null,
        ybsxm: null,
        dgrq: null,
        // yrzw: null,
        // xrzw: null,
        relation: null,
        attitude: null,
        work_experience: null,
        charact: null,
        ygzdwzw: null,
        ygzdw: null,
        phone: null,
        dgrq: null,
        rlhzw: null,
        rlqx: null,
        yrxm: null,
        bgzt: "1",
        hobbies: null,
        // details: null,
        ylys: null,
        blys: null,
      },
      rules: {
        xmbh: [{ required: true, message: "项目不能为空", trigger: "change" }],

        rlsj: [
          { required: true, message: "离任时间不能为空", trigger: "change" },
        ],
        ygzdw: [
          { required: true, message: "原工作单位不能为空", trigger: "change" },
        ],
        ygzdwzw: [
          {
            required: true,
            message: "原工作单位职务不能为空",
            trigger: "change",
          },
        ],
        ybsxm: [
          {
            required: true,
            message: "现一把手姓名不能为空",
            trigger: "change",
          },
        ],
        dgrq: [
          { required: true, message: "到岗日期不能为空", trigger: "change" },
        ],
        // yrzw: [
        //   { required: true, message: "原任职务不能为空", trigger: "change" },
        // ],
        // xrzw: [
        //   { required: true, message: "现任职务不能为空", trigger: "change" },
        // ],
        relation: [
          {
            required: true,
            message: "是否与天维合作过不能为空",
            trigger: "change",
          },
        ],
        attitude: [
          {
            required: true,
            message: "是否认可天维不能为空",
            trigger: "change",
          },
        ],
        work_experience: [
          { required: true, message: "工作履历不能为空", trigger: "change" },
        ],

        // charact: [
        //   { required: true, message: "性格特征不能为空", trigger: "change" },
        // ],
        ygzdwzw: [
          {
            required: true,
            message: "原工作单位职务不能为空",
            trigger: "change",
          },
        ],
        ygzdw: [
          { required: true, message: "原工作单位不能为空", trigger: "change" },
        ],
        phone: [
          // { required: true, message: "联系方式不能为空", trigger: "change" },
          { required: true, validator: validatePhoneTwoRuler, trigger: "blur" },
        ],
        dgrq: [
          { required: true, message: "到岗时间不能为空", trigger: "change" },
        ],
        rlhzw: [
          { required: true, message: "离任后职务不能为空", trigger: "change" },
        ],
        rlqx: [
          { required: true, message: "离任后去向不能为空", trigger: "change" },
        ],
        yrxm: [
          {
            required: true,
            message: "原一把手姓名不能为空",
            trigger: "change",
          },
        ],
        bgzt: [
          { required: true, message: "是否到岗不能为空", trigger: "change" },
        ],
      },
      disableXm: false,
    };
  },
  created() {
    this.$store
      .dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        bmbh: null,
      })
      .then(() => {
        if (this.mxParams) {
          getYbsbgsqById({ id: this.mxParams.id }).then((res) => {
            if (res.code == 0) {
              this.form = { ...res.data, xmbh: +res.data.xmbh };
              this.form.rlsj = this.form.rlsj
                ? moment(this.form.rlsj + "")
                : null;
              this.form.dgrq = this.form.dgrq
                ? moment(this.form.dgrq + "")
                : null;
              this.disableXm = true;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.mxParams = {};
          this.mxParams.xmbh = null;
        }
      });
    if (this.zxlc.gxrjsList.length == 0) {
      this.$store.dispatch("zxlc/fetchGxrjsListAction");
    }
    if (this.zxlc.khtdList.length == 0) {
      this.$store.dispatch("zxlc/fetchKhtdListAction");
    }
    if (this.zxlc.zwgxList.length == 0) {
      this.$store.dispatch("zxlc/fetchZwgxListAction");
    }
  },
  mounted() {},

  methods: {
    handleXm(e) {},
    saveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = {};
          if (this.form.bgzt == "1") {
            params = {
              ...this.form,
              rlsj: formatMomentDate(this.form.rlsj),
              dgrq: formatMomentDate(this.form.dgrq),
            };
          } else {
            params = {
              id: this.form.id,
              xmbh: this.form.xmbh,
              bgzt: this.form.bgzt,
            };
          }
          saveYbsbgsq(params).then((res) => {
            if (res.code == 0) {
              if (this.form.bgzt == "1" && this.disableXm == false) {
                insertProgram({ xmbh: this.form.xmbh }).then((res) => {
                  if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.$emit("giveFather");
                  } else {
                    this.$message.error(res.msg);
                  }
                });
              } else {
                this.$message.success(res.msg);
                this.$emit("giveFather");
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .vue-treeselect__multi-value-item {
  display: block;
  height: 36px;
  line-height: 36px;
}
::v-deep .vue-treeselect__multi-value {
  height: 40px;
}
</style>